
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { TrainerTable } from "@/components/trainers/trainer-table"
import { AddTrainerDialog } from "@/components/trainers/add-trainer-dialog"

export default function TrainersPage() {
  const { t } = useTranslation()
  const [isAddTrainerOpen, setIsAddTrainerOpen] = useState(false)

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold tracking-tight">{t("trainers.title")}</h2>
        <Button onClick={() => setIsAddTrainerOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          {t("trainers.addTrainer")}
        </Button>
      </div>
      <TrainerTable />
      <AddTrainerDialog open={isAddTrainerOpen} onOpenChange={setIsAddTrainerOpen} />
    </div>
  )
}
